import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { BillingHistoryPage } from '@/billing/pages/billing-history';

export const Route = createFileRoute('/billing/history')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: BillingHistoryRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function BillingHistoryRoute() {
  return <BillingHistoryPage/>;
}
